import { ChangeDetectionStrategy, Component, HostBinding, Input, input, output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import {
  Entity,
  EntityPermissionActivityKeys,
  Lookup,
  LookupKeys,
  MMDDYYYY_DATE_TIME_FORMAT, SUPPORTED_LANGUAGES_LOOKUP,
  USER_AGREEMENT_STATUSES_LOOKUP,
  UserAgreementManagement,
  UserAgreementManagementKeys,
  UserAgreementStatus,
} from '@ag-common-lib/public-api';

@Component({
  selector: 'ag-shr-users-agreements-grid',
  templateUrl: './subversions-grid.component.html',
  styleUrls: ['./subversions-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubversionsGridComponent {
  @HostBinding('class') className = 'ag-subversions-grid';
  @ViewChild('subversionsGridRef', { static: false }) subversionsGridComponent!: DxDataGridComponent;

  canEdit = input<boolean>(true);
  canDelete = input<boolean>(true);
  canCreate = input<boolean>(true);
  mode = input<'shot' | 'default' >('shot');
  showColumnHeaders = input<boolean >(true);

  @Input() subversions: UserAgreementManagement[];

  subversionChanges = output<UserAgreementManagement>();

  protected readonly BaseModelKeys = BaseModelKeys;
  protected readonly LookupKeys = LookupKeys;
  protected readonly EntityPermissionActivityKeys = EntityPermissionActivityKeys;
  protected readonly Entity = Entity;
  protected readonly UserAgreementStatus = UserAgreementStatus;
  protected readonly emptyMessage: string = 'No Users Agreements Currently Exist';
  protected readonly UserAgreementManagementKeys = UserAgreementManagementKeys;
  protected readonly userAgreementStatusesLookup = USER_AGREEMENT_STATUSES_LOOKUP;
  protected readonly supportedLanguagesLookup = SUPPORTED_LANGUAGES_LOOKUP;
  protected readonly dateFormat = MMDDYYYY_DATE_TIME_FORMAT;

  protected onSubversionChanged(e: { selectedRowsData: UserAgreementManagement[] }) {
    const item = e?.selectedRowsData?.[0] ?? null;
    this.subversionChanges.emit(item);
  }

  getLanguageDescription = (row) => {
    const found = this.supportedLanguagesLookup.find(
      (item) => item[LookupKeys.value] === row[UserAgreementManagementKeys.language]
    );
    return found ? found[LookupKeys.description] : '';
  };
}
